export const styles = {
  container: {
    maxWidth: 1400,
    margin: '0 auto',
  },
  titleWrap: {
    textAlign: 'center',
    marginBottom: 20,
  },
  title: {
    color: 'var(--text-primary)',
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
    marginBottom: 24,
  },
  stepDot: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 700,
    fontFamily: "'Inter', sans-serif",
    background: 'var(--toggle-bg)',
    color: 'var(--text-hint)',
    transition: 'all 0.2s',
  },
  stepDotActive: {
    background: 'var(--btn-gradient)',
    color: 'white',
    boxShadow: '0 2px 6px rgba(93, 64, 55, 0.3)',
  },
  stepDotDone: {
    background: '#43a047',
    color: 'white',
  },
  stepLine: {
    width: 40,
    height: 2,
    background: 'var(--border-light)',
  },
  stepDescription: {
    textAlign: 'center',
    fontSize: 14,
    color: 'var(--text-muted)',
    fontWeight: 500,
    margin: '-12px 0 20px',
    fontFamily: "'Inter', sans-serif",
  },
  modeBtn: {
    padding: '11px 28px',
    border: 'none',
    borderRadius: 9,
    background: 'transparent',
    color: 'var(--text-muted)',
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    transition: 'all 0.2s',
  },
  modeActive: {
    background: 'var(--card-bg)',
    color: 'var(--text-primary)',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
  },
  modeDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  tileCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    padding: '10px 8px',
    border: '1px solid var(--border-main)',
    borderLeft: '3px solid',
    borderRadius: 10,
    background: 'var(--card-bg)',
    boxShadow: 'var(--shadow-card)',
  },
  select: {
    padding: '7px 8px',
    borderRadius: 7,
    border: '1px solid var(--border-light)',
    fontSize: 14,
    width: '100%',
    textAlign: 'center',
    fontFamily: "'Inter', sans-serif",
    outline: 'none',
    cursor: 'pointer',
    background: 'var(--card-bg)',
    color: 'var(--text-body)',
  },
  step2Container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  portHint: {
    textAlign: 'center',
    fontSize: 13,
    color: 'var(--text-hint)',
    margin: '8px 0 0',
    fontWeight: 500,
  },
  uploadSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0',
  },
  uploadBox: {
    textAlign: 'center',
    padding: '40px 60px',
    border: '2px dashed var(--border-light)',
    borderRadius: 16,
    background: 'var(--card-bg)',
  },
  uploadIcon: {
    fontSize: 40,
    marginBottom: 12,
    filter: 'grayscale(0.3)',
  },
  uploadHint: {
    color: 'var(--text-body)',
    fontSize: 15,
    fontWeight: 600,
    marginBottom: 4,
  },
  uploadSub: {
    color: 'var(--text-hint)',
    fontSize: 13,
    marginBottom: 16,
  },
  fileInput: {
    margin: '0 auto',
    fontSize: 13,
  },
  fileName: {
    color: 'var(--text-secondary)',
    fontSize: 13,
    fontWeight: 500,
    marginTop: 8,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    marginTop: 28,
  },
  submitBtn: {
    display: 'block',
    padding: '14px 56px',
    background: 'var(--btn-gradient)',
    color: 'white',
    border: 'none',
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(93, 64, 55, 0.3)',
    transition: 'all 0.2s',
    minWidth: 200,
  },
  backBtn: {
    display: 'block',
    padding: '14px 40px',
    background: 'var(--card-bg)',
    color: 'var(--text-secondary)',
    border: '1px solid var(--border-light)',
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    cursor: 'pointer',
    transition: 'all 0.2s',
    minWidth: 140,
  },
  btnDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  validationRow2Col: {
    display: 'flex',
    gap: 14,
  },
  validationBlock: {
    padding: '16px 14px',
    background: 'var(--card-bg)',
    borderRadius: 12,
    border: '1px solid var(--border-main)',
    borderTop: '3px solid',
    boxShadow: 'var(--shadow-card)',
  },
  validationTitle: {
    margin: '0 0 12px 0',
    fontSize: 15,
    color: 'var(--text-primary)',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    fontSize: 12,
    fontWeight: 700,
  },
  validationList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  validationRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 10px',
    borderRadius: 7,
    fontSize: 14,
    gap: 10,
    transition: 'background 0.2s',
  },
  colorDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
  },
  numBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 26,
    height: 22,
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 700,
    padding: '0 5px',
  },
  comingSoon: {
    fontSize: 10,
    fontWeight: 500,
    color: 'var(--text-hint)',
    fontStyle: 'italic',
    marginLeft: 4,
  },
};
